<template>
  <div class="body">
    <el-card class="box-card">
      <el-form :rules="rules" ref="form" :model="form" label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="培训项目" prop="trainingName">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.trainingName"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="部门" prop="associationId">
              <selectTree
                ref="selectTree"
                :disabled="$route.query.type == 'check'"
                :props="{
                  value: 'id', // ID字段名
                  label: 'text', // 显示名称
                  children: 'children' // 子级字段名
                }"
                :options="deptTree"
                :value="form.associationId"
                @getValue="selectTreeChange"
              ></selectTree>
              <!-- <el-select
                :disabled="$route.query.type == 'check'"
                v-model="form.associationId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.id"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="负责人" prop="principalId">
              <el-select
                id="principalId"
                :disabled="$route.query.type == 'check'"
                v-model="form.principalId"
                popper-class='project-filter'
                filterable
                placeholder="请选择，支持查询"
              >
                <el-option
                  v-for="item in principalList"
                  :key="item.id"
                  :label="item.userName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="地点" prop="location">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.location"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="培训讲师" prop="trainer">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.trainer"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="讲师资质" prop="trainerCondition">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.trainerCondition"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="审核人" prop="reviewerName">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="reviewerName"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="考核人" prop="examinerName">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="examinerName"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="填表人" prop="fillerName">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="fillerName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="计划人数" prop="programNumber">
              <el-input
                :disabled="$route.query.type == 'check'"
                type="number"
                v-model="form.programNumber"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="实到人数" prop="actualNumber">
              <el-input
                :disabled="$route.query.type == 'check'"
                type="number"
                v-model="form.actualNumber"
              ></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="培训对象" prop="trainingObj">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.trainingObj"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="培训学时" prop="trainingClassHours">
              <el-input
                :disabled="$route.query.type == 'check'"
                type="number"
                v-model="form.trainingClassHours"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="时间" prop="date">
              <el-date-picker
                :disabled="$route.query.type == 'check'"
                v-model="form.date"
                type="datetimerange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="培训目的" prop="trainingContent">
              <el-input
                :disabled="$route.query.type == 'check'"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入内容"
                v-model="form.trainingContent"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="考核结果" prop="assessmentResult">
              <el-input
                :disabled="$route.query.type == 'check'"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入内容"
                v-model="form.assessmentResult"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row>
          <el-col :span="6">
            <el-form-item label="培训结果上传" prop="dataIntroduction">
              <el-upload>
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row>
          <el-col :span="6">
            <el-form-item label="教学方式" prop="teachingMethods">
              <el-checkbox-group v-model="form.teachingMethods">
                <el-checkbox
                  :disabled="$route.query.type == 'check'"
                  v-for="(item, index) in teaching_methods"
                  :key="index"
                  :label="item.id"
                >{{ item.text }}
                </el-checkbox
                >
                <!-- <el-checkbox
                  :disabled="$route.query.type == 'check'"
                  label="0"
                  >线下培训</el-checkbox
                > -->
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="考核方式" prop="assessmentMethod">
              <el-checkbox-group v-model="form.assessmentMethod">
                <el-checkbox
                  :disabled="$route.query.type == 'check'"
                  v-for="(item, index) in assess_methods"
                  :key="index"
                  :label="item.id"
                >{{ item.text }}
                </el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          {{form.trainingProgramName}}
          <el-col :span="6">
            <el-form-item label="关联培训计划">
              <span v-if="isTxtShow" :v-model="txtVale" :style="$route.query.type == 'check'? 'color: #C0C4CC;':''" >{{form.safetyTrainingProgramName}}</span>
              <el-button   v-if="isButtonShow" size="mini" @click="onProgram">点击</el-button>
              <el-button  type="text"  v-if="isUpdateShow "  :disabled="$route.query.type == 'check'" size="mini" @click="editProgram()">修改</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="培训附件">
              <el-button size="mini" @click="uploadVisible = true">上传</el-button>
            </el-form-item>
          </el-col>
        </el-row>

<!--addPerson(0)   isShowSelectPerson  = true -->
        <el-button
          @click="addPerson()"
          type="primary"
          v-if="$route.query.type != 'check'"
        >添加培训人员
        </el-button
        >

        <el-table :data="personList" style="width: 100%" class="mb20">
          <el-table-column
            type="index"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column prop="label" label="培训人员"></el-table-column>
          <el-table-column label="培训时数">
            <template slot-scope="scope">
              <el-input-number
                :precision="0"
                :disabled="$route.query.type == 'check'"
                :max="9999"
                :min="0"
                v-model="personList[scope.$index].trainingHours">
              </el-input-number>
<!--              -->
<!--              <el-input-->
<!--                :disabled="$route.query.type == 'check'"-->
<!--                type="number"-->
<!--                v-model="personList[scope.$index].trainingHours"-->
<!--              ></el-input>-->
            </template>
          </el-table-column>
          <el-table-column label="考核成绩">
            <template slot-scope="scope">
              <el-input-number
                :disabled="$route.query.type == 'check'"
                v-model="personList[scope.$index].examScorce"
                :precision="2"
                :max="9999">
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="培训效果">
            <template slot-scope="scope">
<!-- scope.row.trainingEffect-->
              <el-radio-group
                :disabled="$route.query.type == 'check'"
                v-model="personList[scope.$index].trainingEffect"
              >
                <el-radio label="0">差</el-radio>
                <el-radio label="1">可</el-radio>
                <el-radio label="2">良</el-radio>
                <el-radio label="3">优</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <el-input
                :disabled="$route.query.type == 'check'"
                type="text"
                v-model="personList[scope.$index].remark"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="$route.query.type != 'check'">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="personList.splice(scope.$index, 1)"
              >删除
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-button
          v-if="$route.query.type != 'check'"
          @click="save"
          type="primary"
        >保存
        </el-button
        >
        <el-button v-else @click="exportFile" type="primary">导出</el-button>
        <el-button @click="$router.go(-1)" type="primary">返回</el-button>
      </el-form>
    </el-card>

    <!-- 选择培训人员弹窗 -->
    <el-dialog title="选择用户" :visible.sync="isShowSelectPerson" width="70%">
      <div class="f-c">
        <div style="heigth:100%;margin-right:100px;">
          <div class="mb10">
            <el-radio v-model="userSelection" label="0">用户</el-radio>
            <el-radio v-model="userSelection" label="1">部门</el-radio>
            <el-radio v-model="userSelection" label="2">岗位</el-radio>
            <el-radio v-model="userSelection" label="3">角色</el-radio>
          </div>

          <el-tree
            v-show="userSelection == 0"
            :props="props"
            :data="deptTree"
            show-checkbox
            @check-change="treeChange1"
          ></el-tree>
          <el-tree
            v-show="userSelection == 1"
            :props="props"
            :data="deptTree"
            show-checkbox
            @check-change="treeChange2"
          ></el-tree>
          <div v-show="userSelection == 3">
            <el-checkbox-group v-model="selectRoleList">
              <div v-for="(item, index) in roleList" :key="index">
                <el-checkbox :label="index">{{ item.roleName }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>

        <el-transfer
          v-show="userSelection == 0"
          :titles="['未选择', '已选择']"
          :data="transferData1"
          v-model="transferModel1"
        ></el-transfer>
        <el-transfer
          v-show="userSelection == 1"
          :titles="['未选择', '已选择']"
          :data="transferData2"
          v-model="transferModel2"
        ></el-transfer>
        <el-transfer
          v-show="userSelection == 3"
          :titles="['未选择', '已选择']"
          :data="transferData4"
          v-model="transferModel4"
        ></el-transfer>
      </div>

      <span slot="footer">
        <el-button @click="isShowSelectPerson = false">取 消</el-button>
        <el-button type="primary" @click="selectPersonComfirm">确 定</el-button>
      </span>
    </el-dialog>





    <el-dialog title="文件上传窗口" custom-class="multipleImgDialog hp90" append-to-body :visible.sync="uploadVisible">
      <el-upload-e listType="picture" :fileList="fileList" :coreProp="coreProp"
                   :accept="'.docx,.pdf,.zip,.doc,.xlsx,.xls'"></el-upload-e>
    </el-dialog>

    <userSelection ref="userSelection" @submit="selectPersonComfirms"></userSelection>
    <trainingProgram ref="trainingProgram" @submit="selectProgram"></trainingProgram>
  </div>
</template>

<script>

import api from "../../api/new/training.js";
import api_user from "@/api/api_user.js";
import exam from "@/api/new/exam.js";
import api_role from "@/api/api_role.js";
import util from "@/common/util.js";
import training from "@/api/new/training";
import selectTree from "@/components/common/selectTree";
//附件操作api
import attApi from '@/api/api_att';

import elUploadEmp from '@/components/common/uploadEmpList';
import elUploadE from '@/components/common/uploadMultiple';
import userSelection from '@/pages/trainingManagement/component/user/userSelection.vue';
import trainingProgram from '@/pages/trainingManagement/safetyTrainingProgram/trainingProgram/list.vue';
export default {
  components: {
    selectTree,
    elUploadE,
    elUploadEmp,
    userSelection,
    trainingProgram
  },
  data() {
    return {
      txtVale:'',
      isTxtShow:false,
      isButtonShow:true,
      isUpdateShow:false,
      // 附件 start
      uploadVisible: false,
      //编辑时渲染的文件列表
      fileList: [],
      //新版组件内置变量
      coreProp: {
        //文件保存后 缓存已保存的文件id列表
        fileIds: [],
        //文件是否被改变过,用于在关闭表单时判断是否需要再次进行保存的依据
        isChange: false
      },
      //附件  end

      departmentList: [],
      principalList: [],
      teaching_methods: [],
      assess_methods: [],
      personList: [],
      form: {
        date: [],
        trainingProgramId: undefined,
        trainingProgramName:undefined,
        trainingName: undefined,
        associationName: undefined,
        associationId: undefined,
        principalId: undefined,
        principalName: undefined,
        location: undefined,
        trainer: undefined,
        trainerCondition: undefined,
        startTime: undefined,
        endTime: undefined,
        teachingMethods: [],
        assessmentMethod: [],
        assessmentResult: undefined,
        programNumber: undefined,
        actualNumber: undefined,
        trainingContent: undefined,
        safetyTrainingProgramId:undefined,
        trainingRecordJoinUserList: [],
        trainingObj: undefined,
        trainingClassHours: undefined,
        trainingResourcesSaveDtos: [
          {
            resourcesPath: "资源路径"
          }
        ]
      },
      rules: {
        trainingObj: [{required: true, message: "请输入培训对象", trigger: "blur"}],
        trainingClassHours: [{required: true, message: "请输入培训学时", trigger: "blur"}],

        trainingName: [{required: true, message: "请输入培训项目", trigger: "blur"}],
        associationName: [
          {required: true, message: "请选择部门", trigger: "blur"}
        ],
        associationId: [{required: true, message: "请选择部门"}],
        principalId: [{required: true, message: "请选择负责任人"}],
        principalName: [{required: true, message: "请选择负责任人", trigger: "blur"}],
        location: [{required: true, message: "请输入地点", trigger: "blur"}],
        trainer: [{required: true, message: "请输入培训讲师", trigger: "blur"}],
        trainerCondition: [
          {required: true, message: "请输入讲师资质", trigger: "blur"}
        ],
        teachingMethods: [{required: true, message: "请选择教学方式"}],
        assessmentMethod: [{required: true, message: "请选择考核方式"}],
        assessmentResult: [
          {required: true, message: "请输入考核结果", trigger: "blur"}
        ],
        programNumber: [{required: true, message: "请输入计划人数", trigger: "blur"}],
        actualNumber: [{required: true, message: "请输入实到人数", trigger: "blur"}],
        trainingContent: [
          {required: true, message: "请输入培训目的", trigger: "blur"}
        ],
        date: [{required: true, message: "请选择培训时间", trigger: "blur"}]
      },

      reviewerName: undefined,
      examinerName: undefined,
      fillerName: undefined,

      isShowSelectPerson: false, // 选择培训人员弹窗
      deptTree: [],
      selectPaperIndex: 0, //
      programDetail: {},
      transferData1: [], // 穿梭框左边边的数据
      transferModel1: [], // 穿梭框右边的数据
      transferData2: [], // 穿梭框左边边的数据
      transferModel2: [], // 穿梭框右边的数据
      transferData3: [], // 穿梭框左边边的数据
      transferModel3: [], // 穿梭框右边的数据
      transferData4: [], // 穿梭框左边边的数据
      transferModel4: [], // 穿梭框右边的数据
      props: {
        label: "text",
        children: "children"
      },
      userSelection: "0",
      selectTaskIndex: 0,
      roleList: [],
      selectRoleList: [],
      dept: {},
    };
  },
  mounted() {


    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));
    // this.departmentList = JSON.parse(localStorage.getItem("departmentList"));
    this.teaching_methods = JSON.parse(
      localStorage.getItem("teaching_methods")
    );
    this.assess_methods = JSON.parse(localStorage.getItem("assess_methods"));

    if (this.$route.query.id) this.getOfflineDetail();
    this.getRole();

    if(this.$route.query.type == 'check'){
        this.isUpdateShow =false;
    }
  },
  methods: {
    //修改培训计划选择
    editProgram(){
      console.log(this.form.trainingProgramId)
      console.log(this.form.safetyTrainingProgramName)
      this.$refs.trainingProgram.edit(this.form.safetyTrainingProgramId,this.form.safetyTrainingProgramName);
    },
    //打开选择培训计划提示框
    onProgram(){
      this.$refs.trainingProgram.show();
    },
    //赋值
    selectProgram(date){
      // console.log(date)
      // console.log(date.id)
      // console.log(date.trainingProgramName)
      this.isButtonShow=false;
      this.form.safetyTrainingProgramId=date.id;
      this.form.safetyTrainingProgramName=date.trainingProgramName;
      this.txtVale=date.trainingProgramName;

      // console.log(this.form.safetyTrainingProgramName)
      this.isTxtShow=true;
      // this.isUpdateShow=true

    },
    selectPersonComfirms(date){
      this.personList=date
      console.log(date)
    },
    addPerson(){
      console.log(this.personList)

      this.$refs.userSelection.showCompare(this.personList,"key","label")
      // this.$refs.userSelection.show(this.personList);
      this.$nextTick(() => {
        this.$refs.userSelection.showCompare(this.personList,"key","label")
        // this.$refs.userSelection.show(this.personList);
      });
    },
    selectTreeChange(v) {
      console.log(v)
      this.dept = v;
      this.form.associationId = parseInt(v.id);
    },
    exportFile() {
      training
        .recordOfflineExport({
          id: this.$route.query.id
        })
        .then(res => {
          console.log(res);
          util.downloadBlobFile(res, "线下培训管理导出.docx");
        });
    },
    getRole() {
      api_role
        .findList({
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        })
        .then(res => {
          this.roleList = res.rows;
        });
    },
    getOfflineDetail: function () {

      this.isButtonShow = false;
      this.isTxtShow = true;
      this.isUpdateShow = true;

      api
        .getOfflineDetail({
          dataId: this.$route.query.id
        })
        .then(res => {
          let data = res.data;
          this.form.date = [
            new Date(data.trainingStartTime).getTime(),
            new Date(data.trainingEndTime).getTime()
          ];
          this.form.safetyTrainingProgramId=data.safetyTrainingProgramId;
          this.form.safetyTrainingProgramName=data.safetyTrainingProgramName;
          this.txtVale = data.safetyTrainingProgramName;
          this.form.trainingProgramName = data.trainingProgramName;
          this.form.trainingProgramId = data.trainingProgramId
          this.form.trainingName = data.trainingName;
          this.form.associationName = data.associationName;
          this.form.associationId = parseInt(data.associationId);
          this.form.principalId = parseInt(data.principalId);
          this.form.principalName = data.principalName;
          this.form.location = data.location;
          this.form.trainer = data.trainer;
          this.form.trainerCondition = data.trainerCondition;
          this.form.trainerCondition = data.trainerCondition;
          this.form.trainingObj=data.trainingObj;
          this.form.trainingClassHours=data.trainingClassHours;
          let teachingMethods = data.teachingMethods.split(",");
          let assessmentMethod = data.assessmentMethod.split(",");
          teachingMethods.forEach(v => {
            this.form.teachingMethods.push(parseInt(v));
          });
          assessmentMethod.forEach(v => {
            this.form.assessmentMethod.push(parseInt(v));
          });

          this.form.assessmentResult = data.assessmentResult;
          this.form.programNumber = data.programNumber;
          this.form.actualNumber = data.actualNumber;
          this.form.trainingContent = data.trainingContent;

          this.reviewerName = data.reviewerName;
          this.examinerName = data.examinerName;
          this.fillerName = data.fillerName;



        var  cons=[];

          data.trainingRecordJoinUserList.forEach(v => {
            v.examScorce = v.examScorce,
              v. key = v.busiId,
              v.label = v.busiName,
              v.personType= v.busiType,
              v.trainingHours=v.trainingHours,
              v.trainingEffect=v.trainingEffect ===null ?'':v.trainingEffect.toString(),
              v.remark= v.remark ==null ?'':v.remark

          });
          // console.log(data.trainingRecordJoinUserList)

          data.trainingRecordJoinUserList.forEach(v => {
            cons.push({
             examScorce : v.examScorce,
              key : v.busiId,
             label : v.busiName,
              personType: v.busiType,
             trainingHours:v.trainingHours,
              trainingEffect:v.trainingEffect ===null ?'':v.trainingEffect.toString(),
              remark:v.remark ==null ?'':v.remark
            })
          });

console.log(cons)
          this.personList =  data.trainingRecordJoinUserList;

          //获取附件列表
          if (data.attIds) {
            let parmas = {
              ids: data.attIds
            }
            attApi.getAttByIds(parmas).then(res => {
              if (res.code == 0 && res.list && res.list.length > 0) {
                res.list.forEach((o, i) => {
                  var file = {
                    id: o.id,
                    name: o.name,
                    //url要加点料 (拼接全连接名)
                    url: process.env.API_ROOT + '/api-base' + o.url
                  };
                  this.fileList.push(file);
                });
                this.coreProp.fileIds = data.attIds.split(',');
              }
            });
          }
        });
    },
    save() {
      this.$refs.form.validate(validate => {
        //if (validate == false) return this.$message.error("请填写表单");
        if (this.personList.length == 0) {
          return this.$message.error("请添加培训人员");
        }
        let p = {
          ...this.form,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId,
          trainningRecordType: 0
        };
        if (p.date.length > 0) {
          p.startTime = p.date[0];
          p.endTime = p.date[1];
        }

        p.teachingMethodsString = [];
        p.assessmentMethodString = [];
        this.teaching_methods.forEach(v => {
          if (p.teachingMethods.indexOf(v.id) > -1) {
            p.teachingMethodsString.push(v.text);
          }
        });
        this.assess_methods.forEach(v => {
          if (p.assessmentMethod.indexOf(v.id) > -1) {
            p.assessmentMethodString.push(v.text);
          }
        });
        p.teachingMethodsString = p.teachingMethodsString.join(",");
        p.assessmentMethodString = p.assessmentMethodString.join(",");
        p.teachingMethods = p.teachingMethods.join(",");
        p.assessmentMethod = p.assessmentMethod.join(",");

        delete p.date;

        // this.departmentList.forEach(v => {
        //   if (v.id == p.associationId) p.associationName = v.deptName;
        // });
        p.associationName = this.dept.text
        this.principalList.forEach(v => {
          if (v.id == p.principalId) p.principalName = v.userName;
        });

        //附件列表
        //文件id列表
        p.attIds = '';
        if (this.coreProp.fileIds && this.coreProp.fileIds.length > 0) {
          p.attIds = this.coreProp.fileIds.join(',');
        }

        this.personList.forEach(v => {
          p.trainingRecordJoinUserList.push({
            busiId: v.key,
            busiName: v.label,
            busiType: v.personType,
            trainingEffect: v.trainingEffect,
            trainingHours: v.trainingHours,
            examScorce: v.examScorce,
            reviewerName: this.reviewerName,
            examinerName: this.examinerName,
            fillerName: this.fillerName,
            remark: v.remark
          });
        });

        if (this.$route.query.id) {
          p.id = this.$route.query.id;
        }
        api.addOffline(p).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.$router.go(-1);
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    selectPersonComfirm() {
      this.isShowSelectPerson = false;

      let a = [];
      if (this.userSelection == 0) {
        this.transferData1.forEach(v => {
          this.transferModel1.forEach(v2 => {
            if (v.key == v2) a.push(v);
          });
        });
      }
      if (this.userSelection == 1) {
        this.transferData2.forEach(v => {
          this.transferModel2.forEach(v2 => {
            if (v.key == v2) a.push(v);
          });
        });
      }
      if (this.userSelection == 3) {
        this.transferData4.forEach(v => {
          this.transferModel4.forEach(v2 => {
            if (v.key == v2) a.push(v);
          });
        });
      }

      this.personList = a;
    },
    treeChange1(data, isSelect) {
      api_user
        .listNopagging({
          deptId: data.id
        })
        .then(res => {
          if (isSelect) {
            res.forEach(person => {
              this.transferData1.push({
                key: person.id,
                label: person.userName
              });
            });
          } else {
            res.forEach((v, i) => {
              this.transferData1.forEach((v2, i2) => {
                if (v.id == v2.key) this.transferData1.splice(v2, 1);
              });
            });
          }
        });
    },
    treeChange2(data, isSelect) {
      if (isSelect) {
        this.transferData2.push({
          key: data.id,
          label: data.text
        });
      } else {
        this.transferData2.forEach((v, i) => {
          if (v.key == data.id) {
            this.transferData2.splice(i, 1);
          }
        });
      }
    }
  },
  watch: {
    selectRoleList(v) {
      let arr = [];
      v.forEach(item => {
        arr.push({
          key: this.roleList[item].id,
          label: this.roleList[item].roleName
        });
      });
      this.transferData4 = arr;
    },
    "form.associationId": function (deptId) {
      api_user.getByDept({deptId}).then(res => {
        this.principalList = res.data;
      });
    }
  }
};
</script>

<style  >
.el-select-dropdown__list{
  max-height: 500px;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/addLatoja.vue